export default __webpack_public_path__ + "f8315c8ba893751c9fc842872e21a0fa.jpg";